'use client';

import Link from 'next/link';
import classes from './HorizontalMapCard.module.scss';
import { Button, Container, Grid } from '@mantine/core';
import { useAOS } from '@/src/lib/hooks/useAOS';
import { useDictionary } from '@/src/dictionaries/dictionary-provider';

type HorizontalMapCardProps = {
  title: string;
  description: string;
  backgroundGradient: string;
  button?: string;
  buttonColor?: string;
  buttonHref?: string;
  position: 'left' | 'right';
  src: string; // URL for the image
};

export const HorizontalMapCard = ({ data }: { data: HorizontalMapCardProps }) => {
  const { title, description, button, buttonColor, buttonHref, position, src } = data;
  useAOS();
  const dictionary = useDictionary();

  console.log(dictionary.address);

  return (
    <div className={classes.wrapper}>
      <Container data-aos="zoom-in">
        <Grid
          align="center"
          gutter="lg"
          className={classes.grid}
          style={{
            flexDirection: position === 'left' ? 'row-reverse' : 'row', // Dynamically reverse layout
          }}
        >
          {/* Image Column */}
          {position === 'left' && (
            <Grid.Col span={{ base: 12, sm: 6 }} className={classes.imageCol} data-aos="flip-left">
              <h2 className={classes.titleMobile}>{title}</h2>
              <iframe
                title="Map"
                style={{ width: '100%', height: 280, border: 0, borderRadius: 8 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps?q=${encodeURIComponent(dictionary.address)}&output=embed`}
              />
            </Grid.Col>
          )}

          {/* Text Column */}
          <Grid.Col span={{ base: 12, sm: 6 }} className={classes.textCol}>
            <h2 className={classes.title}>{title}</h2>
            <p className={classes.description}>{description}</p>
            {button && (
              <Button component={Link} href={buttonHref ?? ''} size="md" className={classes.button}>
                {button}
              </Button>
            )}
          </Grid.Col>

          {position !== 'left' && (
            <Grid.Col span={{ base: 12, sm: 6 }} className={classes.imageCol} data-aos="flip-right">
              <h2 className={classes.titleMobile}>{title}</h2>
              <iframe
                title="Map"
                style={{ width: '100%', height: 280, border: 0, borderRadius: 8 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps?q=${encodeURIComponent(dictionary.address)}&output=embed`}
              />
            </Grid.Col>
          )}
        </Grid>
      </Container>
    </div>
  );
};
